module.exports = __webpack_public_path__ + "media/images/star_icon_50-ecd78299d5931dce764e009c4c9e7368.svg";